<template>
	<el-form>
		<div class="row middle margin-bottom-20">
			<div class="col-lg-4 col-sm-12">
				<label class="no-margin-top">
					{{ translations.labels.widgetDuration }}
					<span :data-tooltip="translations.labels.tooltipWidgetDuration">
						<i class="el-icon-info" />
					</span>
				</label>
			</div>
			<div class="col-lg-8 col-sm-12">
				<el-input-number
					v-model="settings.duration"
					:step="0.5"
					:min="0.5"
					controls-position="right"
					style="width: 100%"
				/>
			</div>
		</div>
		<div class="row middle margin-bottom-20">
			<div class="col-lg-4 col-sm-12">
				<label class="no-margin-top required">
					{{ translations.labels.weekStartsOn }}
				</label>
			</div>
			<div class="col-lg-8 col-sm-12">
				<el-select
					v-model="settings.startsOn"
					:placeholder="translations.labels.selectStartDay"
					class="wide"
				>
					<el-option
						v-for="(unit, index) in options"
						:key="index"
						:label="unit"
						:value="unit"
					/>
				</el-select>
			</div>
		</div>
		<div class="row middle margin-bottom-20">
			<div class="col-lg-4 col-sm-12">
				<label class="no-margin-top">
					{{ translations.labels.color }}
				</label>
			</div>
			<div class="col-lg-8 col-sm-12">
				<el-color-picker
					v-model="settings.color"
					size="medium"
				/>
			</div>
		</div>
		<div class="row middle margin-bottom-20">
			<div class="col-lg-4 col-sm-12">
				<label class="no-margin-top">
					{{ translations.labels.backgroundColor }}
				</label>
			</div>
			<div class="col-lg-8 col-sm-12">
				<el-color-picker
					v-model="settings.bgColor"
					size="medium"
				/>
			</div>
		</div>
		<div class="flex-end">
			<el-button
				@click="saveSettings()"
				:disabled="isDisabled"
				:type="isDisabled ? 'info' : 'primary'"
				plain
			>
				{{ translations.labels.saveChanges }}
			</el-button>
			<el-button
				@click="closeDialog()"
				plain
			>
				{{ translations.labels.cancel }}
			</el-button>
		</div>
	</el-form>
</template>

<script>
import updateWidgetSettings from '@/services/mixins/updateWidgetSettings'

export default {
    name: 'WidgetSettings',
	props: {
		widget: Object
	},
	mixins: [
		updateWidgetSettings
	],
    data () {
        return {
			settings: {},
			options: ['Sunday', 'Monday']
        }
    },
	computed: {
		isDisabled () {
			return !this.settings.startsOn
		}
	},
	watch: {
		'widget': {
			handler () {
				const defaultSettings = {
					startsOn: null,
					color: '#000',
					bgColor: '#fff',
					duration: 2
				}
				this.settings = this.objectLength(this.widget.settings) ? this.clone(this.widget.settings) : defaultSettings
			},
			immediate: true
		}
	}
}
</script>
